module.exports = __webpack_public_path__ + "static/media/audio-player1.997f5ebc.png";